import { render, staticRenderFns } from "./PoseResult.vue?vue&type=template&id=0ee2fd21&"
import script from "./PoseResult.vue?vue&type=script&lang=js&"
export * from "./PoseResult.vue?vue&type=script&lang=js&"
import style0 from "./PoseResult.vue?vue&type=style&index=0&id=0ee2fd21&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports